/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Form from "../../../components/Form";
// import { get } from "lodash";
import useForm from "../../../hooks/useForm";
import Modal, { ModalHeader } from "../../../components/Modal";
import {
  createVacationsOthers,
  modifyVacationsOthers,
} from "../../../apis/vacation/vacation-other";
import { isEmpty } from "lodash";
import systemAlert from "../../../utils/systemAlert";
import { findModeLabel } from "../../../utils/mode";

const OtherVacation = ({ list, open, setOpen, submit, mode, setMode }) => {
  const [formFields, setFormFields] = useState([]);

  const validate = ({ title }) => {
    let errors = {};

    if (title.length > 100) {
      errors.title = "기타휴가명 필수입니다.(100글자 이내)";
    }

    return errors;
  };

  useEffect(() => {
    setFormFields([
      [{ title: "기타휴가명", key: "title", type: "input", required: true }],
      [
        {
          title: "필요사유",
          key: "description",
          type: "input",
        },
      ],
      [
        {
          title: "사용여부",
          key: "isActive",
          type: "radio",
          options: {
            list: [
              { label: "사용", value: "1" },
              { label: "미사용", value: "0" },
            ],
          },
          required: true,
        },
      ],
      [
        {
          title: "사용단위",
          key: "isOnlyDayUsable",
          type: "radio",
          options: {
            list: [
              { label: "종일", value: "1" },
              { label: "반일", value: "0" },
            ],
          },
          required: true,
        },
      ],
      [
        {
          title: "유급/무급",
          key: "isPaid",
          options: {
            list: [
              { label: "유급", value: "1" },
              { label: "무급", value: "0" },
            ],
          },
          type: "radio",
          required: true,
        },
      ],
    ]);
  }, []);

  const defaultForm = {
    title: "",
    description: "",
    isActive: "1",
    isOnlyDayUsable: "1",
    isPaid: "1",
  }

  useEffect(() => {
    if (!isEmpty(list)) {
      const formData = {
        ...list,
        isActive: list.isActive ? "1" : "0",
        isOnlyDayUsable: list.isOnlyDayUsable ? "1" : "0",
        isPaid: list.isPaid ? "1" : "0",
      };
      setForm(formData);
    } else {
      setForm(defaultForm)
    }
  }, [list]);

  useEffect(() => {
    setValidateFields(formFields)
  }, [open, formFields])

  const _submit = (form) => {
    const data = {
      ...form,
      isActive: Boolean(Number(form.isActive)),
      isOnlyDayUsable: Boolean(Number(form.isOnlyDayUsable)),
      isPaid: Boolean(Number(form.isPaid)),
    };
    if (mode === "create") {
      systemAlert('새휴가를 작성하시겠습니까?', {
        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '승인',
            onClick: () => {
              createVacationsOthers(data)
                .then(() => {
                  submit();
                  setOpen(false);
                })
                .catch((err) => {
                  console.error(err.response);
                })
                .finally(() => { });
            }
          }
        ]
      })
    } else {
      systemAlert('새휴가를 작성하시겠습니까?', {
        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '승인',
            onClick: () => {
              modifyVacationsOthers(list.idx, data)
                .then(() => {
                  setOpen(false);
                  submit();
                })
                .catch((err) => {
                  console.error(err.response);
                })
                .finally(() => { });
            }
          }
        ]
      })
    }
  };

  const { form, setForm, errors, handleOnChange, handleSubmit, setValidateFields } = useForm(
    defaultForm,
    _submit,
    validate
  );

  const cancel = (e) => {
    e.preventDefault();
    setOpen(false);
    setMode('create')
  };

  return (
    <Modal isOpen={open} close={cancel}>
      <div className="grade-write">
        <ModalHeader>
          기타 휴가 {findModeLabel(mode)}
        </ModalHeader>
        <Form
          mode={mode}
          fields={formFields}
          form={form}
          onChange={handleOnChange}
          submit={handleSubmit}
          cancel={cancel}
          errors={errors}
        />
      </div>
    </Modal>
  );
};

export default OtherVacation;
